import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AccountService } from '../services/services.module';
import { EmailConfirmationComponent } from './../portal/email-confirmation/email-confirmation.component';
import { OpenDialog } from './dialogs/dialog';

@Injectable()
export class EmailConfirmationPopup implements CanActivate {
  constructor(private router: Router, private accountService: AccountService) {}

  async canActivate() {
    if (this.accountService.currentUser) {
      if (!this.accountService.currentUser.emailVerified) {
        let result = await OpenDialog(EmailConfirmationComponent);
        return result;
      }
      return true;
    } else {
      return this.accountService
        .loadCurrentUserFromServer()
        .then(async (data) => {
          if (this.accountService.currentUser) {
            if (!this.accountService.currentUser.emailVerified) {
              let result = await OpenDialog(EmailConfirmationComponent);
              if (result) {
                return result;
              } else {
                this.router.navigate(['/']);
              }
            }
            return true;
          }
        })
        .catch(() => {
          return false;
        });
    }
  }
}
